import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tunPopupContent]',
})
export class PopupContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
